import type { ReactNode } from "react";

import { ItemComments } from "./ItemComments";
import type { PriceChildren } from "./ItemPrice";
import { ItemPriceAndVendor } from "./ItemPriceAndVendor";
import { ItemTitle } from "./ItemTitle";

export interface ItemDetailsProps {
  clamped: boolean;
  showVendor: boolean;
  vendor: string | null | undefined;
  showPrice: boolean;
  price: PriceChildren;
  showTitle: boolean;
  title: string | ReactNode | null | undefined;
  showComments: boolean;
  comments: string | null | undefined;
}

export function ItemDetails(props: ItemDetailsProps) {
  const {
    clamped,
    showVendor,
    vendor,
    showPrice,
    price,
    showTitle,
    title,
    showComments,
    comments,
  } = props;

  return (
    <div className="item--details" data-test-id="item-details">
      <ItemPriceAndVendor
        vendor={showVendor ? vendor : null}
        price={showPrice ? price : null}
      />
      {showTitle ? <ItemTitle>{title}</ItemTitle> : null}
      {showComments ? (
        <ItemComments clamped={clamped}>{comments}</ItemComments>
      ) : null}
    </div>
  );
}
